import initReviewPage from "components/jiffy/reviews-page/reviews-page";

document.addEventListener("DOMContentLoaded", initReviewPage);
